import { createEffect, sample } from 'effector';
import api from 'services/api';
import { BasketSubmissionType } from 'store/basket/interfaces';
import { fetchCatalogEV } from '../events';
import { $catalogServicesStore } from '..';
import { ProfileTypeEnum } from '../../main/interface';

const PATH = '/api-profile/api/v1/catalog';

export const fetchCatalogFX = createEffect(async (params: any = {}) => {
  const {
    submission_type,
    entity_id,
    behalf_of_uuid,
    organization_uuid,
    behalf_of_entity_type,
    is_legal_fact,
    ...rest
  } = params;

  const currentState = $catalogServicesStore.getState();

  if (currentState.servicesToAdd?.length) {
    rest.codes = [];

    currentState.servicesToAdd.forEach((service: any) => {
      rest.codes.push(service.code);
    });
  }

  let currentPath;
  const PARTNER_ORGANIZATION_PATH = `/api-profile/api/v1/partner_organizations/${organization_uuid}/catalog`;

  switch (submission_type) {
    case BasketSubmissionType.LEGAL_ENTITY:
      const responseLE = await api.get(`/api-profile/api/v1/legal_entities/${entity_id}/catalog`, {
        params: rest,
      });

      return { data: responseLE.data.data, params };
    case BasketSubmissionType.PARTNER_ORGANIZATION:
      const responsePartnerOrganization = await api.get(PARTNER_ORGANIZATION_PATH, {
        params: rest,
      });

      return { data: responsePartnerOrganization.data.data, params };
    case BasketSubmissionType.ON_BEHALF_OF_BRANCH:
      const onBehalfResponse = await api.get(
        `/api-profile/api/v1/legal_entities/${entity_id}/catalog/${behalf_of_uuid}`,
        {
          params: rest,
        }
      );

      return { data: onBehalfResponse.data.data, params };
    case BasketSubmissionType.ON_BEHALF_OF_ENTITY:
      currentPath = `${PATH}/${behalf_of_uuid}`;

      if (organization_uuid) {
        if (behalf_of_entity_type === ProfileTypeEnum.LEGAL_ENTITY) {
          if (is_legal_fact) {
            currentPath = `${PARTNER_ORGANIZATION_PATH}/behalf_of/legal_fact/${behalf_of_uuid}`;
          } else {
            currentPath = `${PARTNER_ORGANIZATION_PATH}/behalf_of/legal_entity/${behalf_of_uuid}`;
          }
        } else {
          const lvIdentityNumber = behalf_of_uuid.replace('-', '');

          currentPath = `${PARTNER_ORGANIZATION_PATH}/behalf_of/natural_person/${lvIdentityNumber}`;
        }
      }

      const behalfOfEntityResponse = await api.get(currentPath, { params: rest });

      return { data: behalfOfEntityResponse.data.data, params };
    case BasketSubmissionType.ON_BEHALF_OF_PERSON:
      currentPath = `${PATH}`;

      if (organization_uuid && behalf_of_uuid) {
        const lvIdentityNumber = behalf_of_uuid.replace('-', '');

        currentPath = `${PARTNER_ORGANIZATION_PATH}/behalf_of/natural_person/${lvIdentityNumber}`;
      }

      const behalfOfPersonResponse = await api.get(currentPath, { params: rest });

      return { data: behalfOfPersonResponse.data.data, params };
    default:
      currentPath = `${PATH}`;

      if (submission_type === BasketSubmissionType.ON_BEHALF_OF_FACT && organization_uuid) {
        if (behalf_of_entity_type === ProfileTypeEnum.LEGAL_ENTITY) {
          if (is_legal_fact) {
            currentPath = `${PARTNER_ORGANIZATION_PATH}/behalf_of/legal_fact/${behalf_of_uuid}`;
          } else {
            currentPath = `${PARTNER_ORGANIZATION_PATH}/behalf_of/legal_entity/${behalf_of_uuid}`;
          }
        } else {
          const lvIdentityNumber = behalf_of_uuid.replace('-', '');

          currentPath = `${PARTNER_ORGANIZATION_PATH}/behalf_of/natural_person/${lvIdentityNumber}`;
        }
      }

      const personResponse = await api.get(currentPath, { params: rest });

      return { data: personResponse.data.data, params };
  }
});

/**
 * Fetch service group ID by service code.
 */
export const fetchServiceGroupIdFX = createEffect(async (code: string) => {
  const { data: response } = await api.get(`${PATH}/group/${code}`);

  if (response?.data?.group_id) {
    return response.data.group_id;
  }

  return false;
});

sample({
  clock: fetchCatalogEV,
  target: fetchCatalogFX,
});
